import React, {PropTypes as T} from 'react';

const VenueIcon = ({ width = 32, height = 22, color, className = '' }) => (
  <svg
    aria-label="Venue Icon"
    viewBox="0 0 32 22"
    xmlns="http://www.w3.org/2000/svg"
    fill={color}
    width={width}
    height={height}
    className={`icon__venue ${className}`}>
    <path d="M4.278 5.784a2.393 2.393 0 0 1 .558-1.63c.97-1.208
    3.665-2.646 10.988-2.646 7.32 0 10.029 1.578 11.013 2.903.382.516.515
    1.012.547 1.399-3.327-1.307-7.215-1.97-11.566-1.97-4.305 0-8.186.655-11.54
    1.944zm8.324 14.697l-9.006.017L1.361 8.71c1.105-.74 5.876-3.56 14.457-3.56
    8.578 0 13.244 2.8 14.319 3.536l-2.004 11.768-9.094.014c-.011-.996-.042-4.253
    -.043-7.678.034-.772-.33-1.43-1.027-1.851-1.081-.656-2.954-.645-4.173.022
    -.778.426-1.205 1.066-1.205 1.8l.011 7.72zM31.037 7.705c-.361-.257-1.135
    -.764-2.33-1.327.059-.604.007-1.647-.773-2.711-1.682-2.303-5.757-3.47-12.11
    -3.47-6.309 0-10.359 1.058-12.036 3.145-.691.86-.954 1.859-.785 2.975C1.697
    6.913.856 7.452.465 7.726a1.045 1.045 0 0 0-.447 1.056l2.297 12.117c.1.527.594.909
    1.178.909l9.242-.016c.655-.003 1.189-.495 1.189-1.097v-7.934c0-.305.284-.526.522
    -.656.799-.439 2.145-.461 2.823-.052.286.174.407.39.393.708 0 3.772.038 7.275.045
    7.94.006.594.54 1.08 1.189 1.08l9.349-.017c.587-.001 1.078-.39 1.17-.922l2.066
    -12.1a1.052 1.052 0 0 0-.444-1.037z M9.04 7.258a.693.693 0 0 0-.47.231.574.574
    0 0 0-.14.43l1.05 10.946c.032.318.317.557.665.557l.056-.003a.69.69 0 0 0 .47
    -.23.577.577 0 0 0 .14-.43L9.76 7.811c-.032-.329-.348-.59-.72-.553M4.296 8.538a.674.674
    0 0 0-.455.254.559.559 0 0 0-.113.436l1.528 9.67c.046.3.329.524.659.524.03 0 .06-.003.089
    -.007a.672.672 0 0 0 .456-.251.565.565 0 0 0 .115-.44l-1.528-9.67c-.054-.333-.403-.576-.751
    -.516M21.332 19.42l.056.002c.348 0 .633-.24.664-.557l1.05-10.947a.576.576 0 0 0-.14
    -.428.688.688 0 0 0-.47-.233c-.37-.034-.687.217-.72.555l-1.05 10.947a.575.575 0 0 0
     .14.43.695.695 0 0 0 .47.23M25.528 19.415a.696.696 0 0 0 .091.007c.328 0 .611-.225.659
     -.523l1.527-9.67a.559.559 0 0 0-.113-.436.673.673 0 0 0-.454-.255c-.373-.041-.701.184
     -.752.517l-1.527 9.669a.563.563 0 0 0 .113.439c.106.138.272.23.456.252" />
  </svg>
);

VenueIcon.propTypes = {
  width: T.number,
  height: T.number,
  color: T.string,
  className: T.string
};

export default  VenueIcon;



// WEBPACK FOOTER //
// ./frontend/react/components/common/icons/icon_venue.js